var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"main"},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.guests,"items-per-page":20}}),_c('h1',{staticClass:"ma-15"},[_vm._v("אורחים: "+_vm._s(_vm.count))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }